
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { singularityStore, globalStore } from "@/store/store";
import Step1 from "@/components/Singularity/Step1/Step1.vue";
import SingularityLeftPanelNew from "@/components/Singularity/SingularityLeftPanelNew.vue";
import SingularityRightPanel from "@/components/Singularity/SingularityRightPanel.vue";
import SingularityFullWidthPanel from "@/components/Singularity/SingularityFullWidthPanel.vue";
import TopNavBuilder from "@/components/Singularity/TopNav/TopNavBuilder.vue";
import SingularityCanvas from "./SingularityCanvas/SingularityCanvas.vue";
import { startAutosaveService } from "@/futurelayer/autosave/autosave";
import SingularitySectionLibraryModal from "@/components/Singularity/SingularitySectionLibraryModal/SingularitySectionLibraryModal.vue";
import OutOfCreditsModal from "@/components/Singularity/OutOfCreditsModal.vue";
import PlanExpiredModal from "@/components/Singularity/PlanExpiredModal.vue";
import { logEvent } from "@/util/tracking";
import { getFrontendUrl } from "@/lib/document";

@Component({
  components: {
    Step1,
    SingularityCanvas,
    SingularityLeftPanelNew,
    SingularityRightPanel,
    TopNavBuilder,
    SingularitySectionLibraryModal,
    OutOfCreditsModal,
    PlanExpiredModal,
    SingularityFullWidthPanel
  }
})
export default class Singularity extends Vue {
  get singularityUiState() {
    return singularityStore.singularityUiState;
  }

  get isSectionLibraryModalOpen() {
    return singularityStore.isSectionLibraryModalOpen;
  }

  get isStep1() {
    return this.singularityUiState.singularityFullWidthPanel === "step1";
  }

  async mounted() {
    startAutosaveService();
    logEvent("FutureLayer Loaded", {
      businessName:
        globalStore.aiSettings.prompt.businessName || "Unknown business name",
      businessDescription:
        globalStore.aiSettings.prompt.businessDescription ||
        "Uenknown business description",
      url: getFrontendUrl()
    });
  }

  closeSectionLibraryModal() {
    singularityStore.setSectionLibraryModalState(false);
  }

  get isPreviewMode() {
    return singularityStore.previewMode;
  }

  get isFullWidthState() {
    return !!this.singularityUiState.singularityFullWidthPanel;
  }

  get classes() {
    return {
      "singularity--full-width": this.isFullWidthState,
      [this.singularityUiState.singularityLeftPanel
        ? `singularity--${this.singularityUiState.singularityLeftPanel}`
        : ""]: true,
      "singularity--with-left-panel":
        this.singularityUiState.singularityLeftPanel &&
        !this.singularityUiState.singularityRightPanel,
      "singularity--with-right-panel":
        this.singularityUiState.singularityRightPanel &&
        !this.singularityUiState.singularityLeftPanel,
      "singularity--with-both-panels":
        this.singularityUiState.singularityRightPanel &&
        this.singularityUiState.singularityLeftPanel,
      "singularity--preview-mode": this.isPreviewMode
    };
  }
}
